import classNames from 'classnames'
import React, { ReactElement, ReactNode } from 'react'
import { Text } from '../text/Text'

interface HeaderProps {
  name: ReactNode
  children?: ReactNode
}

export function CardHeader({ name, children }: HeaderProps): ReactElement {
  return (
    <div className="flex justify-between p-6 pb-4">
      <Text as="div" semiBold textType="base-black">
        {name}
      </Text>
      {children}
    </div>
  )
}

interface ContentProps {
  children: ReactElement
}

export function CardContent({ children }: ContentProps): ReactElement {
  return children
}

interface FooterProps {
  children: ReactNode
}

export function CardFooter({ children }: FooterProps): ReactElement {
  return <div className="p-6 pt-4 text-base flex justify-between">{children}</div>
}

export interface CardProps extends React.HTMLProps<HTMLDivElement> {
  hover?: boolean
  selected?: boolean
}

export function Card({ className, children, hover, selected, ...props }: CardProps): ReactElement {
  return (
    <div
      className={classNames(
        'bg-theme-surface drop-shadow-02 rounded-lg',
        hover && selected && 'hover:shadow-hover-selected',
        selected && 'bg-primary-100! shadow-selected',
        hover && !selected && 'hover:bg-gray-100! hover:shadow-gray-500',
        hover && 'cursor-pointer',
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
}
